export const TIME_SLOT_NO_LONGER_AVAILABLE_MESSAGE =
  'Unfortunately this time is no longer available, please go back and choose another time.';

export const TIME_SLOT_NO_LONGER_AVAILABLE_CODE = 'time-slot-no-longer-available';

export const isTimeSlotNoLongerAvailableError = (errorCode: string): boolean =>
  errorCode === TIME_SLOT_NO_LONGER_AVAILABLE_CODE;
